import { useTraitAnalyticsData } from '@common-vue/media-card-large/src/composables/useTraitAnalyticsData';
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useBrand } from '@composables/useBrand';
import { useProductType } from '@composables/useProductType';
import { usePageData } from '@composables/usePageData';
import { useProductPrice } from '@modules/price/composables';
import { useProductData } from '@composables/useProductData';

export default function tagColorChange({ id }) {
  const { isConsolidatedMaster } = useProductType({ id });
  const { isMcom } = useBrand();
  const pageData = usePageData();
  const { product } = pageData.product;
  const store = useStore();
  const availabilityData = computed(() => store.state.availabilityStore.data);
  // TODO: refactor this  -  tagColorChange should not know about useProductPrice
  const selectedProduct = useProductData(id);
  const selectedPrice = useProductPrice({ id, product: selectedProduct });
  const productPricingState = computed(() => [String(selectedPrice.value?.priceTypeId || 'ZERO')]);

  const { fireTagOnChange } = useTraitAnalyticsData({
    isConsolidatedMaster,
    isMcom,
    product,
  });

  return {
    fireTag: () => {
      const selectedSddData = availabilityData.value?.upcNumberSddMap || {};

      fireTagOnChange({
        isColorChage: true,
        productPricingState: productPricingState.value,
        selectedSddData,
      });
    },
  };
}
